<script lang="ts">
  import type { Component, Snippet } from 'svelte';
  interface Props {
    icon?: Component<any>;
    title: string;
    description?: string;
    compact?: boolean;
    actions?: Snippet;
  }
  let { icon: Icon, title, description, compact = false, actions }: Props = $props();
</script>

<div class="empty" class:compact>
  {#if Icon}
    <div class="icon"><Icon size={compact ? 20 : 26} strokeWidth={1.75} /></div>
  {/if}
  <h3>{title}</h3>
  {#if description}<p>{description}</p>{/if}
  {#if actions}<div class="actions">{@render actions()}</div>{/if}
</div>

<style>
  .empty { display: flex; flex-direction: column; align-items: center; text-align: center; padding: var(--space-12) var(--space-6); gap: var(--space-2); }
  .compact { padding: var(--space-6) var(--space-4); }
  /* A plain line icon, no coloured blob behind it. */
  .icon { display: grid; place-items: center; color: var(--text-3); margin-bottom: var(--space-1); }
  .compact .icon { margin-bottom: 0; }
  h3 { font-size: var(--text-md); }
  .compact h3 { font-size: var(--text-base); }
  p { color: var(--text-2); font-size: var(--text-base); max-width: 380px; }
  .actions { display: flex; gap: var(--space-2); margin-top: var(--space-3); flex-wrap: wrap; justify-content: center; }
</style>
